import axios from 'axios';
import { event } from 'vue-analytics';
import LogRocket from 'logrocket';
import {router} from '@/router';
import store from '@/store';
import moment from 'moment';

import {
	LOGIN,
	NEW_USER,
	CONFIRM_NEW_USER,
	GET_USER_DATA,
	PASSWORD_RESET_EMAIL,
	PASSWORD_RESET_CHECK,
	PASSWORD_RESET_CODE,
	PRODUCTION_COMPANY,
	ROAD_LIST,
	INTERSECTION_LIST,
	FACILITY_LIST,
	ADDRESS_NUMBER_LIST,
	ADDRESS_NAME_LIST,
	SUBMIT_APPLICATION,
	RESEND_EMAIL,
	SAVE_FORMDATA,
	RETRIEVE_SAVEDFORMDATA,
	DEACTIVE_SAVEDFORMDATA,
	//DEACTIVE_SAVEDAPPDATA,
	UPDATE_COPYSTATUS

} from '@/constants/api.js';

import {
	ILLEGAL_CHARACTERS,
	GRID_RESET
} from '@/constants/constants.js';
//import { faBullseye } from '@fortawesome/free-solid-svg-icons';

export default {
	ADD_LOCATION({ commit, dispatch }, info) {
		return new Promise((resolve) => {
			commit('ADD_LOCATION', info)
			commit('UPDATE_PARKING_LOCATIONS_LIST');
			dispatch('BACKUP_FORMDATA');
			resolve();
		});
	},
	REMOVE_LOCATION({ commit, dispatch }, info) {
		commit('REMOVE_LOCATION', info)
		commit('UPDATE_PARKING_LOCATIONS_LIST');
		dispatch('BACKUP_FORMDATA');
	},
	MODIFY_LOCATION({ commit, dispatch }, info) {
		commit('MODIFY_LOCATION', info)
		commit('UPDATE_PARKING_LOCATIONS_LIST');
		dispatch('BACKUP_FORMDATA');
	},
	MODIFY_LOCATION_FIELD({ commit, dispatch }, data) {
		commit('MODIFY_LOCATION_FIELD', data);
		commit('UPDATE_PARKING_LOCATIONS_LIST');
		dispatch('BACKUP_FORMDATA');
	},
	COMPLETE_STEP({ commit, dispatch }, data) {
		commit('COMPLETE_STEP', data);
		dispatch('BACKUP_FORMDATA');
		if (data.complete) dispatch('NEXT_STEP');
	},
	UPDATE_FORM_FIELD({ commit, dispatch }, data) {
		commit('UPDATE_FORM_FIELD', data);
		dispatch('BACKUP_FORMDATA');
		// We only back up data on step complete, state is preserved in the store
		// Don't want to be writing so often to sessionStorage
	},
	TOGGLE_DATE({ commit, dispatch }, data) {
		commit('TOGGLE_DATE', data);
		dispatch('BACKUP_FORMDATA');
		// We only back up data on step complete, state is preserved in the store
		// Don't want to be writing so often to sessionStorage
	},
	UPDATE_LOCATION_TYPES({ commit }, data) {
		commit('UPDATE_LOCATION_TYPES', data);
	},
	UPDATE_PRIVATE_ADDRESS_FIELD({ commit, dispatch, state }, { index, field, data }) {
		// Logic for road changes
		if (field == 'AddressName') {
			// Is this a valid road name from the list?
			const isValidated = state.roadList.includes(data);

			// If the road name is different than the previous one, get the address number list for the new one.
			if (state['Address' + String(index + 1) + 'List'].road != data && isValidated) {
				dispatch('GET_ADDRESS_NUMBERS_LIST', { road: data, index });
			}
		}

		commit('UPDATE_PRIVATE_ADDRESS_FIELD', { index, field, data });
		dispatch('BACKUP_FORMDATA');
	},
	RESET_FORM({ commit }) {
		return new Promise((resolve) => {
			sessionStorage.removeItem('saved_form');
			commit('RESET_FORM');
			//router.push({ name: "Dashboard" })
			resolve();
		})
	},
	BACKUP_FORMDATA({ state }) {
		/* Whenever something changes, we backup the form data and some lists to sessionStorage. You don't want users losing data on a refresh. Let's key it to the user email so we can offer it to them if they're still authenticated. No personal info is stored, and we save some bandwidth and xhr time by storing some lists. */

		const savedForm = {
			formData: Object.assign({}, state.formData),
			parkingLocations: [...state.parkingLocations],
			locationTypes: Object.assign({}, state.locationTypes),
			steps: Object.assign({}, state.steps),
			email: state.user.Email,
			saved: Date.now(),
			formType: state.formType,
			weatherDate: state.weatherDate,
			prepDate: state.prepDate,
			wrapDate: state.wrapDate,
			newManager: state.newManager,
			Address1List: state.Address1List,
			Address2List: state.Address2List,
		
		}

		sessionStorage.setItem('saved_form', JSON.stringify(savedForm));
	},
	RECOVER_FORMDATA({ commit, dispatch, state }) {
		return new Promise((resolve) => {
			const recoveredForm = JSON.parse(sessionStorage.getItem('saved_form')) || null;
			const expired = recoveredForm ? Date.now() - recoveredForm.saved > 1800000 : null;

			// If there's no data to recover, resolve
			if (recoveredForm === null) resolve('no data found');

			// If the form is old or if the email doesn't match the current user's email, dispose of the data
			if (expired || recoveredForm.email != state.user.Email) {
				sessionStorage.removeItem('saved_form');
				commit('RESET_FORM');
				resolve('removed old data');
			} else {
				commit('RECOVER_FORMDATA', recoveredForm);
				recoveredForm.formData.SelectedFilmingLocationList.forEach((item, index) => {
					if (item.AddressName) {
						dispatch('GET_ADDRESS_NUMBERS_LIST', { road: item.AddressName, index })
					}
				})
				resolve('found data');
			}

		})
	},
	AUTH_REQUEST({ commit, dispatch }, { username, password }) {
		return new Promise((resolve, reject) => {
			commit('LOADING', true);
			commit('AUTH_REQUEST');
			axios({ url: LOGIN, data: "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password) + "&grant_type=password", method: 'POST', mode: 'no-cors' })
				.then(({ data }) => {
					const tokenObject = Object.assign({ created_time: Date.now() }, data);
					sessionStorage.setItem('access_token', JSON.stringify(tokenObject)); // store the token in sessionStorage
					commit('AUTH_SUCCESS', data.access_token);
					dispatch('USER_LOGIN', data.access_token);
					resolve(data.access_token);
				})
				.catch(function ({ response }) {
					commit('AUTH_ERROR', response);
					sessionStorage.removeItem('access_token'); // if the request fails, remove any possible user token if possible
					commit('LOADING', false);

					event('error', 'token-request', 'login', response);
					reject(response.data);
				})
		})
	},
	AUTH_PASSWORD_RESET_EMAIL(context, data) {
		return new Promise((resolve, reject) => {
			axios({
				url: PASSWORD_RESET_EMAIL,
				data: data,
				method: "post",
				headers: {
					"content-type": "application/json"
				}
			})
				.then(({ data }) => {
					resolve(data);
				})
				.catch(err => {
					event('error', 'password-reset-email', 'pw-reset', err);
					reject('error', err);
				});
		});
	},
	AUTH_PASSWORD_RESET_CHECK(context, data) {
		return new Promise((resolve, reject) => {
			axios({
				url: PASSWORD_RESET_CHECK + data,
				method: "get"
			})
				.then(resp => {
					if (resp.data.Id != undefined) {
						resolve('success');
					} else {
						resolve('failed');
					}
				})
				.catch(err => {
					event('error', 'password-reset-check', 'pw-reset', err);
					reject('failed');
				});
		});
	},
	AUTH_CONFIRM_NEW_USER(context, data) {
		return new Promise((resolve, reject) => {
			axios({
				url: CONFIRM_NEW_USER + data,
				method: "get"
			})
				.then(resp => {
					if (resp.data.Id != undefined) {
						resolve('success');
					} else {
						resolve('failed');
					}
				})
				.catch(err => {
					event('error', 'confirm-new-user', 'new-account', err);
					reject('failed');
				});
		});
	},
	AUTH_PASSWORD_RESET_CODE(context, data) {
		return new Promise((resolve, reject) => {
			axios({
				url: PASSWORD_RESET_CODE,
				data: data,
				method: "post",
				headers: {
					"content-type": "application/json"
				}
			})
				.then(() => {
					resolve('success');
				})
				.catch(err => {
					event('error', 'password-reset-code', 'pw-reset', err);
					reject('failed');
				});
		});
	},
	AUTH_RESEND_VERIFY_EMAIL({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADING', true);
			axios({
				url: RESEND_EMAIL,
				data: JSON.stringify(data),
				method: "post",
				headers: {
					"content-type": "application/json"
				}
			})
				.then(resp => {
					commit('LOADING', false);
					resolve(resp);
				})
				.catch(err => {
					commit('LOADING', false);
					event('error', 'password-reset-code', 'pw-reset', err);
					reject('failed');
				});
		});
	},
	AUTH_NEW_USER({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADING', true);
			axios({
				url: NEW_USER,
				data: data,
				method: "post",
				headers: {
					"content-type": "application/json"
				}
			})
				.then(resp => {
					if (resp === 'register_error') resolve('failed');
					commit('LOADING', false);
					resolve("success");
				})
				.catch(err => {
					commit('LOADING', false);
					event('error', 'create-new-user', 'new-user', err);
					reject("failed");
				});
		})
	},
	USER_LOGIN({ commit, dispatch }, token) {
		return new Promise((resolve, reject) => {
			commit('LOADING', true);
			commit('LOADING', 'Fetching your account information. This can take up to a minute.');
			axios({
				method: 'GET',
				url: GET_USER_DATA,
				headers: {
					'Authorization': 'Bearer ' + String(token)
				}
			})
				.then(({ data }) => {
					commit('USER_LOGIN', data.User);
					const { Id, FirstName } = data.User;
					LogRocket.identify(FirstName, {
						id: Id || 'no id'
					});

					dispatch('GET_PRODUCTION_COMPANIES', token).then(() => {
						dispatch('GET_ROAD_LIST');
						dispatch('GET_FACILITY_LIST');
						commit('LOADING', false);
						resolve();
					})
					/* BKUP: Commented out ReCover Form Data from Auto Save 
					dispatch('RECOVER_FORMDATA').then(() => {
						commit('SET_LATEST_COMPLETED_STEP');
						commit('LOADING', false);
						resolve();
					});
					*/
					
				})
				.catch(err => {
					event('error', 'get-user-info', 'login', err);
					commit('LOADING', false);
					reject('Error retrieving the user. You were logged in but something went wrong fetching your account information. ', err);
				});
		})
	},
	USER_LOGOUT({ commit }, removeData = false) {
		return new Promise((resolve) => {
			// If the dispatcher asked for the backup to be cleared
			if (removeData) {
				sessionStorage.removeItem('saved_form');
			}
			commit('RESET_FORM');
			sessionStorage.removeItem('access_token'); // clear your user's token from sessionStorage
			commit('USER_LOGOUT');
			resolve();
		})
	},
	SET_STEP({ commit }, step) {
		commit('SET_STEP', step);
	},
	NEXT_STEP({ commit }) {
		commit('NEXT_STEP');
	},
	SET_LATEST_COMPLETED_STEP({ commit }) {
		commit('SET_LATEST_COMPLETED_STEP');
	},
	GET_PRODUCTION_COMPANIES({ commit }, token) {
		return new Promise((resolve, reject) => {
			axios({
				url: PRODUCTION_COMPANY,
				method: 'POST',
				data: "",
				headers: {
					'Authorization': 'Bearer ' + token
				}
			})
				.then(resp => {
					commit('GET_PRODUCTION_COMPANIES', resp.data);
					resolve();
				})
				.catch((err = 'Unknown error.') => {

					event('error', 'get-prod-companies', 'get-lists', err);
					reject('An error occured while fetching the production companies. Here\'s what we know about the error: ', err);
				})
		})
	},
	GET_ROAD_LIST({ commit }, data) {
		return new Promise((resolve, reject) => {
			let query = '';
			if (data) {
				// sanitize data before it hits the server
				query = String(data).toUpperCase().split('').filter(char => {
					if (ILLEGAL_CHARACTERS.indexOf(char) == -1) {
						return char;
					}
				}).join('');
			}
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			axios({
				url: ROAD_LIST,
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(({ data }) => {
					const roadData = data.map(({ StreetRoadName }) => StreetRoadName);
					commit('GET_ROAD_LIST', roadData);

					return data;
				})
				.then(data => {
					let roadIdList = {};
					data.forEach(({ StreetRoadName, StreetRoadId }) => roadIdList[StreetRoadName] = StreetRoadId);

					commit('GET_ROAD_ID_LIST', roadIdList);
					resolve();
				})
				.catch((err = 'Unknown error.') => {

					event('error', 'get-road-list', 'get-lists', err);
					reject('An error occured while fetching the road list. Here\'s what we know about the error: ', err);
				})
		})
	},
	GET_INTERSECTION_LIST({ commit }, data) {
		return new Promise((resolve, reject) => {
			let query = '';
			if (data) {
				// sanitize data before it hits the server
				query = String(data).toUpperCase().split('').filter(char => {
					if (ILLEGAL_CHARACTERS.indexOf(char) == -1) {
						return char;
					}
				}).join('');
			}
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			axios({
				url: INTERSECTION_LIST,
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(({ data }) => {
					const intersectionData = data.map(item => item.IntersectionName);
					commit('GET_INTERSECTION_LIST', intersectionData);
					resolve();
				})
				.catch((err = 'Unknown error.') => {

					event('error', 'get-intersection-list', 'get-lists', err);
					reject('An error occured while fetching the road list. Here\'s what we know about the error: ', err);
				})
		})
	},
	GET_ADDRESS_NAME_LIST({ commit }, data) {
		return new Promise((resolve, reject) => {
			let query = '';
			if (data) {
				// sanitize data before it hits the server
				query = String(data).toUpperCase().split('').filter(char => {
					if (ILLEGAL_CHARACTERS.indexOf(char) == -1) {
						return char;
					}
				}).join('');
			}
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			axios({
				url: ADDRESS_NAME_LIST,
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(({ data }) => {
					const addressNames = data.map(item => item.AddressName);
					commit('GET_ADDRESS_NAME_LIST', addressNames);
					resolve();
				})
				.catch((err = 'Unknown error.') => {

					event('error', 'get-address-name-list', 'get-lists', err);
					reject('An error occured while fetching the road list. Here\'s what we know about the error: ', err);
				})
		})
	},
	GET_ADDRESS_NUMBERS_LIST({ commit }, { road, index }) {
		return new Promise((resolve, reject) => {
			commit('LOADING', true);
			let query = '';
			if (road) {
				// sanitize data before it hits the server and remove road suffixes since we are using the roads endpoint
				query = String(road).toUpperCase().split('').filter(char => {
					if (ILLEGAL_CHARACTERS.indexOf(char) == -1) {
						return char;
					}
				}).join('');
			}
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			axios({
				url: ADDRESS_NUMBER_LIST,
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(({ data }) => {
					const addressList = data.map(({ AddressKey, AddressNumber }) => {
						return {
							key: AddressKey,
							number: AddressNumber
						}
					});
					commit('GET_ADDRESS_NUMBERS_LIST', { addressList, road, index });
					commit('UPDATE_PRIVATE_ADDRESS_FIELD', { field: false, index, data: null })
					commit('LOADING', false);
					if (addressList.length == 0) event('empty-resp', 'get-address-numbers-list', 'get-lists', road);
					resolve();
				})
				.catch((err = 'Unknown error.') => {
					commit('LOADING', false);

					event('error', 'get-address-numbers-list', 'get-lists', err);
					reject('An error occured while fetching the address numbers list. Here\'s what we know about the error: ', err);
				})
		})
	},
	GET_FACILITY_LIST({ commit }, data) {
		return new Promise((resolve, reject) => {
			let query = '';
			if (data) {
				// sanitize data before it hits the server
				query = String(data).toUpperCase().split('').filter(char => {
					if (ILLEGAL_CHARACTERS.indexOf(char) == -1) {
						return char;
					}
				}).join('');
			}
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			axios({
				url: FACILITY_LIST,
				method: 'POST',
				data: JSON.stringify(query),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(({ data }) => {
					let locationLists = {
						facilities: [],
						parks: [],
						assetIdList: {}
					}

					data.forEach(item => {
						item.FacilityType === 'Park' ? locationLists.parks.push(item.FacilityName) : locationLists.facilities.push(item.FacilityName);
						locationLists.assetIdList[item.FacilityName] = item.AssetId;
					})
					commit('GET_FACILITY_LIST', locationLists);
					resolve();
				})
				.catch((err = 'Unknown error.') => {

					event('error', 'get-facility-list', 'get-lists', err);
					reject('An error occured while fetching the road list. Here\'s what we know about the error: ', err);
				})
		})
	},
	SUBMIT_APPLICATION({ commit, getters }, captchaToken) {
		commit('LOADING', true);
		return new Promise((resolve, reject) => {
			//grab token from sessionStorage
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			let data = Object.assign({}, getters.getFormData);
			//console.log("SaveAppId from formData: " + data.SavedAppId);
			//console.log("SaveAppId from getters: " + getters.savedAppId);

			// If the form is a grid form, reset any data that a user may have entered for locations if they started as a permit form and switched mid-way.
			if (getters.formType === 'grid') {
				data = Object.assign(data, GRID_RESET)
			}

			if (getters.newProductionCompany) data.CompanyContactId = 0;

			data.Recaptcha_Token = captchaToken;
			axios({
				url: SUBMIT_APPLICATION,
				method: 'POST',
				data: JSON.stringify(data),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(resp => {
					commit('LOADING', false);
					if (resp.data.IsSuccess) {
						sessionStorage.removeItem('saved_form');
						commit('FORM_SUBMIT_SUCCESS', resp.data);
						resolve('success');
					} else {
						resp == 'application_input_error' ? resolve('input error') : resolve('server error');
					}
				})
				.catch((err = 'Unknown error.') => {
					commit('LOADING', false);

					event('error', 'submit-form', 'submit', err);
					reject('An error occured while submitting the application. Here\'s what we know about the error: ', err);
				})
		})
	},
	SET_TYPE({ dispatch, commit }, type, backup = true) {
		commit('SET_TYPE', type);
		backup ? dispatch('BACKUP_FORMDATA') : null;
	},
	TOGGLE_NEW_PROD_COMPANY({ commit }, val) {
		commit('TOGGLE_NEW_PROD_COMPANY', val);
	},
	TOGGLE_NEW_MANAGER({ commit }, val) {
		commit('TOGGLE_NEW_MANAGER', val);
	},

	//########################## Phase 2 ##########################
	SAVE_FORMDATA({ commit, getters},captchaToken) {
		commit('LOADING', true);
		return new Promise((resolve, reject) => {
		const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
		let data = Object.assign({}, getters.getFormData);
		//console.log("formData object: " + JSON.stringify(data));
		//console.log("Save Form: " + data.SavedAppId);

		//To change value for private address location due to the data type conflict
		//when call  API with Json Deserialize Object
		if(data.SelectedFilmingLocationList[0].AddressKey=='')
			data.SelectedFilmingLocationList[0].AddressKey = 0;
		if(data.SelectedFilmingLocationList[1].AddressKey=='')
			data.SelectedFilmingLocationList[1].AddressKey = 0;
		if(data.Facility_Building_AssetId=='')
			data.Facility_Building_AssetId = 0;
		if(data.Facility_Park_AssetId=='')
			data.Facility_Park_AssetId = 0;
		data.Step = getters.getStep;
		data.Recaptcha_Token = captchaToken;
		if(data.CompanyContactId=='')
		{
			data.CompanyContactId = 0;
		}

		//assign saved application data
		let savedData = Object.assign({}, getters.formSavedData);
		savedData.formData = JSON.stringify(data);
		savedData.CompanyName = data.CompanyName;
		savedData.ProductionTitle = data.ProductionTitle;
		savedData.FilmingStartDate = data.Filming_StartDate;
		savedData.CityGrid = data.CityGrid === "Y" ? "grid" : "permit";
		savedData.Step = getters.getStep;
		savedData.Id = getters.savedAppId;
		//savedData.ApplicationName = getters.formSavedData.ApplicationName;
		

		axios({
			url: SAVE_FORMDATA,
			method: 'POST',
			data: JSON.stringify(savedData),
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			}
		})
			.then(resp => {
				commit('LOADING', false);
				if (resp.data !="saved_application_input_format_invalid" && resp.data !="error_saved_application" && resp.data.length > 0) {
					sessionStorage.removeItem('saved_form');
					commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
					//if it's a new save, thenwe update the savedAppId with the lastest saved item Id in the return saved items array
					//to avoid the issue of saved duplication from following actions: "Save" and click on "Exit and Save" again.
					if(getters.savedAppId =="") 
					{
						//commit('SETSTATE_VALUE',{name:'Id',value: resp.data[0].Id,type: 'savedFormData'});
						commit('SETSTATE_VALUE',{name:'savedAppId',value: resp.data[0].Id});
					}
					resolve('success');
				} else { //error returns from API -> implementing/display proper msg on UI.
					if(resp.data ==='saved_application_input_format_invalid')
						resolve('input error');
					else if (resp.data ==="error_saved_application")
						resolve('saving process error');
				}
			})
			.catch((err = 'Unknown error.') => {
				commit('LOADING', false);
				event('error', 'save-form', 'save', err);
				reject('An error occured while savinging the application. Here\'s what we know about the error: ', err);
			})
		})
	},

	RETRIEVE_SAVEDFORMDATA({ commit }) {
		commit('LOADING', true);
		return new Promise((resolve, reject) => {		
		const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;

		axios({
			url: RETRIEVE_SAVEDFORMDATA,
			method: 'Get',
				headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			}
		})
			.then(resp => {
				commit('LOADING', false);
				if (resp.data != "no_saved_applications" && resp.data.length != 0 ) {
					/*
					let formSaveDataList=[]
					resp.data.forEach(item => {
						formSaveDataList.push(item)
					})
					*/

					sessionStorage.removeItem('retrivedsaved-formdata');
					//commit('RETRIEVE_SAVEDFORMDATA_SUCCESS', formSaveDataList);
					commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
						
					resolve();
				}
				else //reset saved app list
				{
					commit('RESETSTATE_VALUE',{name:'formSaveDataList',type: 'ArrayTypes'})
				}
			})
			.catch((err = 'Unknown error.') => {
				commit('LOADING', false);	
				event('error', 'retrivedsaved_formdata', 'retrieve', err);
				reject('An error occured while retriveing your data. Here\'s what we know about the error: ', err);
			})
		
		})
	},

    /*Bkup
	DEACTIVE_SAVEDFORMDATA({ commit},id) {  //,getters
		return new Promise((resolve, reject) => {
		const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
		//let data = Object.assign({}, getters.getFormData);

		axios({
			url: DEACTIVE_SAVEDFORMDATA + "/" + id,
			method: 'Put',
			//data: JSON.stringify(data),
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			}
		})
			.then(resp => {
				if(resp.data=="error_deactivate_savedapplication")
				{
					resolve(resp.data);
				}
				else if (resp.data.length != 0 ) {
					commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
					resolve(resp.data);
				}
			})
			.catch((err = 'Unknown error.') => {
			
				event('error', 'deactive_formdata', 'put', err);
				reject('An error occured while deactive your data. Here\'s what we know about the error: ', err);
			})
		})
	},
	*/

	// NEW TESTOUT###############
	DEACTIVE_SAVEDFORMDATA({ commit},obj) {  //,getters
		//const { Id, Step, Stamp } = obj;
		return new Promise((resolve, reject) => {
		const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
		//let data = Object.assign({}, getters.getFormData);

		axios({
			/*
			url: DEACTIVE_SAVEDFORMDATA + "/" + Id,
			//url: DEACTIVE_SAVEDAPPDATA + "/" + id + "/" + step + "/" + stamp,
			method: 'Put',
			//data: JSON.stringify(data),
			*/
			url: DEACTIVE_SAVEDFORMDATA,
			method: 'POST',
			data: JSON.stringify(obj),
			headers: {
				'content-type': 'application/json',
				'Authorization': 'Bearer ' + token
			}
		})
			.then(resp => {
				if(resp.data=="error_deactivate_savedapplication")
				{
					resolve(resp.data);
				}
				else if (resp.data.length != 0 ) {
					commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
					resolve(resp.data);
				}
			})
			.catch((err = 'Unknown error.') => {
			
				event('error', 'deactive_formdata', 'put', err);
				reject('An error occured while deactive your data. Here\'s what we know about the error: ', err);
			})
		})
	},

	
	//GOTO_SAVEDAPP({ commit, getters},appIndex){  
	GOTO_SAVEDAPP({ commit, getters},{appIndex,appType}){
		commit('LOADING', false);
		commit("RESETSTATE_VALUE",{name:'savedAppValidationList', type:'ArrayTypes'});
		//var savedFormData = getters.formSaveDataList[appIndex];
		var savedAppList = [];
		if (appType==='submitted') //submitted applications
		{
			savedAppList = getters.formSaveDataList.filter(x => x.IsSubmitted)
		}
		else //in progress application
		{
			savedAppList = getters.formSaveDataList.filter(x => !x.IsSubmitted) 
		}
		var savedFormData = savedAppList[appIndex];
		//savedFormData.SavedAppId = savedFormData.Id  //overide saveFormData 

		//console.log('GoTo_SavedApp -> savedAppId:' + savedFormData.Id);
		//assign and tracking value for savedAppId
		// commit('UPDATE_FORM_FIELD', {
		// 	field: "SavedAppId",
		// 	data: savedFormData.Id
		// });

		//let savedFormData_Update = Object.assign({}, getters.getFormData);
		//console.log('formData from getters: ' + JSON.stringify(savedFormData_Update));
		//console.log('1. formData -> savedAppId from getters: ' + savedFormData_Update.SavedAppId);
		//var savedFormDataStep = Object.assign({}, savedFormData).Step;


		var data = JSON.parse(savedFormData.FormData)
		commit('SETSTATE_VALUE',{name:'CompanyName',value: savedFormData.CompanyName});
		//commit('SETSTATE_VALUE',{name:'formData',value: savedFormData.FormData,type: 'formData'});
		//Bkup: commit('SETSTATE_VALUE',{name:'formData',value: savedFormData_Update});
		commit('SETSTATE_VALUE',{name:'savedAppId',value: savedFormData.Id});
		commit('SETSTATE_VALUE',{name:'step',value: savedFormData.Step});	
		commit('SETSTATE_VALUE',{name:'formType',value: savedFormData.CityGrid.trim()});
		commit('SETSTATE_VALUE',{name:'ApplicationName',value: savedFormData.ApplicationName,type: 'savedFormData'});
		//BKUP: commit("RETRIVED_SAVED_FORMDATA",JSON.parse(savedFormData.FormData));
		commit("RETRIEVED_SAVED_FORMDATA",JSON.parse(savedFormData.FormData));

		//assign and tracking value for savedAppId
		commit('UPDATE_FORM_FIELD', {
			field: "SavedAppId",
			data: savedFormData.Id
		})

		//console.log('2. formData -> savedAppId from getters: ' + getters.getFormData.SavedAppId);

		//reset steps value before assign it
		//Object.keys(state.steps).forEach((key) => state.steps[key] = false)
		for(var i=1; i<= 5; i++)
			commit("COMPLETE_STEP",{step: i, complete: false});

		/* Commented out: based on the feedback -> just lead user to "step 1"
		//set-assign value for complete steps
		//if the saved app is "submitted" one then don't assign complete step, just default step to step "1"
		if(savedFormDataStep != 99) 
		{
			for(var j=1; j< savedFormData.Step; j++)
				commit("COMPLETE_STEP",{step: j, complete: true});
		}
		*/

		// var data = this.$store.getters.formSaveDataList[appIndex].FormData
		//var data = JSON.parse(savedFormData.FormData)

		//step 1: determine flag values - whether or not to display "new company" and "manager 2" info
		if(data.CompanyName != "" && data.CompanyEmail !="" && savedFormData.DateOfCreation !="")
		{
			//Bkup: commit('TOGGLE_NEW_PROD_COMPANY', false);
			if(data.CompanyContactId == 0)
			{
				commit('TOGGLE_NEW_PROD_COMPANY', true);
			}
			else
			{
				commit('TOGGLE_NEW_PROD_COMPANY', false);
			}
		}
			

		if(data.Manager2FirstName !="" & data.Manager2LastName !="")
			commit('SETSTATE_VALUE',{name:'newManager',value:true});
		else
			commit('SETSTATE_VALUE',{name:'newManager',value:false});

		//step 2: logic for flag values - to determine whether or not to display 
		//var currentDate = moment(new Date().toLocaleString()).format("mm-dd-yyyy");
		var currentDate = moment().format("YYYY-MM-DD");
		var filmStartDate = moment(data.Filming_StartDate).format("YYYY-MM-DD");
		var filmEndDate = moment(data.Filming_EndDate).format("YYYY-MM-DD");
		
		
		if (moment(filmStartDate).isBefore(currentDate))
		{
			commit('SET_SAVEDAPPVALIDATIONLIST', {step: 2,name:'filmStartDate',isValidated: false});
		}		
		if (moment(filmEndDate).isBefore(currentDate))
		{
			commit('SET_SAVEDAPPVALIDATIONLIST', {step: 2,name:'filmEndDate',isValidated: false});
		}	

        //wheather date
        if(data.Weather_Date != "")
		{
			commit('SETSTATE_VALUE',{name:'weatherDate',value:true});
		}		
		else
		{
			commit('SETSTATE_VALUE',{name:'weatherDate',value:false});
			// commit('UPDATE_FORM_FIELD', {
			// 	field: "Weather_Date",
			// 	data: ""
			// });
		}
			
        //prepDate
        if(data.Prep_StartDate != "" && data.Prep_EndDate != "")
			commit('SETSTATE_VALUE',{name:'prepDate',value:true});
		else
			commit('SETSTATE_VALUE',{name:'prepDate',value:false});
        //wrapDate
        if(data.Wrap_StartDate != "" && data.Wrap_EndDate != "")
			commit('SETSTATE_VALUE',{name:'wrapDate',value:true});
		else
			commit('SETSTATE_VALUE',{name:'wrapDate',value:false});

		//step 4: logic for flag values - i.e. "Film Location": to determine whether or not to diplay
		//city own building
		/*
		if (data.Facility_Building_AssetId != 0)	
			commit('SETSTATE_VALUE',{name:'cityBuilding',value:true, type: 'locationTypes'})
		else if(data.Facility_Building_AssetId  === 0 || data.Facility_Building_AssetId === undefined)//reset
			commit('SETSTATE_VALUE',{name:'cityBuilding',value:false, type: 'locationTypes'})
		*/
		if (data.Facility_Building_AssetId === undefined)	//reset
			commit('SETSTATE_VALUE',{name:'cityBuilding',value:false, type: 'locationTypes'})	
		else 
			if(data.Facility_Building_AssetId  != 0)
				commit('SETSTATE_VALUE',{name:'cityBuilding',value:true, type: 'locationTypes'})
		//parks
		if (data.Facility_Park_AssetId === undefined)  //reset
			commit('SETSTATE_VALUE',{name:'cityPark',value:false, type: 'locationTypes'});
		else
			if (data.Facility_Park_AssetId != 0)
				commit('SETSTATE_VALUE',{name:'cityPark',value:true, type: 'locationTypes'});
		
		if (data.SelectedFilmingLocationList.length > 0)
		{
			if(data.SelectedFilmingLocationList[0].AddressKey != 0)
				commit('SETSTATE_VALUE',{name:'privateAddress',value:true, type: 'locationTypes'});

			if(data.SelectedFilmingLocationList[1].AddressKey != 0)
				commit('SETSTATE_VALUE',{name:'privateAddress2',value:true, type: 'locationTypes'});                  
		}

		//step 4 validations
		if(data.Facility_Building_StartDate != '')
		{
			var facilityBuildingStartDate = moment(data.Facility_Building_StartDate).format("YYYY-MM-DD");
			if (moment(facilityBuildingStartDate).isBefore(currentDate))
			{
				commit('SET_SAVEDAPPVALIDATIONLIST', {step: 4,name:'facilityBuildingStartDate',isValidated: false});
			}
		}
		
		if(data.Facility_Building_EndDate != '')
		{
			var facilityBuildingEndDate = moment(data.Facility_Building_EndDate).format("YYYY-MM-DD");			
			if (moment(facilityBuildingEndDate).isBefore(currentDate))
			{
				commit('SET_SAVEDAPPVALIDATIONLIST', {step: 4,name:'facilityBuildingEndDate',isValidated: false});
			}
		}
		

		//step 5 logic for flag values
		if (data.SelectedStreetRoadList.length > 0) 
		{
			//checking for date validation for selected streets/roads
			for(var x=0; x< data.SelectedStreetRoadList.length; x++)
			{
				var streetRoadStartDate = moment(data.SelectedStreetRoadList[x].StreetRoadStartDate).format("YYYY-MM-DD");
				var streetRoadEndDate = moment(data.SelectedStreetRoadList[x].StreetRoadEndDate).format("YYYY-MM-DD");		
				if (moment(streetRoadStartDate).isBefore(currentDate))
				{
					commit('SET_SAVEDAPPVALIDATIONLIST', {step: 5,name:'streetRoadStartDate',isValidated: false});
				}	
				if (moment(streetRoadEndDate).isBefore(currentDate))
				{
					commit('SET_SAVEDAPPVALIDATIONLIST', {step: 5,name:'streetRoadEndDate',isValidated: false});
				}	
			}
			//asign location type
			commit('SETSTATE_VALUE',{name:'street',value:true, type: 'locationTypes'});
		}
			

		if (data.SelectedParkingLocationList.length > 0)
		{
			//checking for date validation for selected parking locations
			for(var y=0; y< data.SelectedParkingLocationList.length; y++)
			{
				var parkingLocationStartDate = moment(data.SelectedParkingLocationList[y].LocationStartDate).format("YYYY-MM-DD");
				var parkingLocationEndDate = moment(data.SelectedParkingLocationList[y].LocationEndDate).format("YYYY-MM-DD");		
				if (moment(parkingLocationStartDate).isBefore(currentDate))
				{
					commit('SET_SAVEDAPPVALIDATIONLIST', {step: 5,name:'parkingLocationStartDate',isValidated: false});
				}	
				if (moment(parkingLocationEndDate).isBefore(currentDate))
				{
					commit('SET_SAVEDAPPVALIDATIONLIST', {step: 5,name:'parkingLocationEndDate',isValidated: false});
				}	
			}
			//asign location type
			commit('SETSTATE_VALUE',{name:'lot',value:true, type: 'locationTypes'});
		}

		//step 6: logic
		commit('SETSTATE_VALUE',{name:'Agreement',value:'N',type:'formData'});
			
		//console.log('3. formData -> savedAppId from getters: ' + savedFormData_Update.SavedAppId);

		//turn off flag value for "isCopied" status
		if(savedFormData.IsCopied)
		{
			store.dispatch("UPDATE_COPYSTATUS",savedFormData.Id);
		}

		//direct user to application page - uncomment the below line if you use "Dashboard"
		router.push({ name: "New application" })
	}, 

	COPY_SAVEDAPP({ commit, getters},{appIndex,appType}){
		//var savedFormData = getters.formSaveDataList[appIndex];
		//var formData = JSON.parse(savedFormData.FormData)

		return new Promise((resolve, reject) => {
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			//var savedFormData = getters.formSaveDataList[appIndex];

			//var copyAppType = 'submitted';
			var savedAppList = [];
			if (appType==='submitted') //submitted applications
			{
				savedAppList = getters.formSaveDataList.filter(x => x.IsSubmitted)
			}
			else //in progress application
			{
				savedAppList = getters.formSaveDataList.filter(x => !x.IsSubmitted) 
			}
			var savedFormData = savedAppList[appIndex];

			savedFormData.IsCopied = true;
			//savedFormData.ApplicationName = getters.applicationName;

			if(savedFormData.IsSubmitted)
				savedFormData.IsSubmitted = false;
	
			axios({
				url: SAVE_FORMDATA,
				method: 'POST',
				data: JSON.stringify(savedFormData),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(resp => {
					commit('LOADING', false);
					if (resp.data !="saved_application_input_format_invalid" && resp.data !="error_saved_application" && resp.data.length > 0) {
						sessionStorage.removeItem('saved_form');
						commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
						resolve('success');
					} else { //error returns from API -> implementing/display proper msg on UI.
						if(resp.data ==="saved_application_input_format_invalid")
						{
							resolve('input error');
						}	
						else if (resp.data ==="error_saved_application")
						{
							resolve('saving process error');
						}		
					}
				})
				.catch((err = 'Unknown error.') => {
					commit('LOADING', false);
					event('error', 'save-form', 'save', err);
					reject('An error occured while saving the application. Here\'s what we know about the error: ', err);
				})
			})
	},

	UPDATE_COPYSTATUS({ commit,getters},id) {
		return new Promise((resolve, reject) => {
			const token = JSON.parse(sessionStorage.getItem('access_token')).access_token;
			let data = Object.assign({}, getters.getFormData);

			axios({
				url: UPDATE_COPYSTATUS + "/" + id,
				method: 'Put',
				data: JSON.stringify(data),
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + token
				}
			})
				.then(resp => {
					
					if (resp.data != "error_update_copystatus" && resp.data.length != 0 ) {
						commit('SETSTATE_VALUE',{name:'formSaveDataList',value: resp.data,type: 'ArrayTypes'});
						resolve();
					}
				})
				.catch((err = 'Unknown error.') => {
				
					event('error', 'deactive_formdata', 'put', err);
					reject('An error occured while deactive your data. Here\'s what we know about the error: ', err);
				})
		})
	},

	SETSTATE_VALUE({commit},val)
	{
		commit('SETSTATE_VALUE', val);
	},

	RESETSTATE_VALUE({commit},val)
	{
		commit('RESETSTATE_VALUE',val);
	}

	/*
	SET_SAVED_APPLICATIONNAME({commit},val)
	{
		commit('SETSTATE_VALUE', {name:'ApplicationName',value: val,type: 'savedFormData'});
	},
	*/
}
